// extracted by mini-css-extract-plugin
export var bigText = "Services-module--big-text--cc873";
export var list = "Services-module--list--60c9f";
export var richText = "Services-module--rich-text--5f085";
export var text = "Services-module--text--97dbe";
export var title = "Services-module--title--af952";
export var wrapper = "Services-module--wrapper--18c5e";